import styled from 'styled-components';

const Textarea = styled.textarea`
  box-sizing: border-box;
  padding: 0.25rem;
  font-size: 1rem;
  background: transparent;
  border: 0;
  min-height: 150px;
  width: 100%;
`;

export default Textarea;
